import {
  FACEBOOK_AUTH_REQUEST,
  GET_PROFILE_FAIL,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  LOGIN_FAIL,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
  REGISTRATION_REQUEST
} from '../actions/auth';

const initialState = {
  token: null,
  loading: false,
  facebookLoading: false,
  isForgotPasswordWebviewOpen: false,
  user: null,
  error: null,
  getProfileError: null,
  updateErrors: []
};

const authReducerStrategy = {
  [LOGOUT]: state => ({
    ...state,
    user: null,
    token: null
  }),
  [LOGIN_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [REGISTRATION_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [FACEBOOK_AUTH_REQUEST]: state => ({
    ...state,
    facebookLoading: true
  }),
  [LOGIN_SUCCESS]: (state, { token, user }) => ({
    ...state,
    user,
    token,
    loading: false,
    facebookLoading: false
  }),
  [LOGIN_FAIL]: (state, { error }) => ({
    ...state,
    error,
    loading: false,
    facebookLoading: false
  }),
  [GET_PROFILE_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [GET_PROFILE_SUCCESS]: (state, { user }) => ({
    ...state,
    user,
    loading: false
  }),
  [GET_PROFILE_FAIL]: (state, { message }) => ({
    ...state,
    getProfileError: message,
    loading: false
  })
};

const authReducer = (state = initialState, action) => {
  const reducer = authReducerStrategy[action.type];
  return (reducer && reducer(state, action)) || state;
};

export default authReducer;
